const subscriptionRoutes = {
  path: 'feeinvoices',
  name: 'feeinvoicesOverview',
  components: {
    default: () => import('@/views/PageRoutView')
  },
  redirect: { name: 'feeinvoices' },
  meta: {
    requiresAuth: true,
  },
  children: [
    {
      path: '/:channelId/feeinvoices',
      name: 'feeinvoices',
      component: () => import('@/views/FeeInvoices/Invoices'),
      meta: {
        requiresAuth: true
      }
    },

    {
      path: '/:channelId/feeinvoices/:feeinvoiceId',
      name: 'feeinvoices-detail',
      component: () => import('@/views/FeeInvoices/InvoiceDetail'),
      meta: {
        requiresAuth: true
      }
    },


  ]
}

export default subscriptionRoutes
